import { Stack, Typography, TypographyProps } from '@mui/material';
import { StackProps } from '@mui/system';
import { FunctionComponent } from 'react';

export type TextHeaderProps = {
  subtitle?: React.ReactNode;
  subtitleProps?: TypographyProps;
  title: React.ReactNode;
  titleProps?: TypographyProps;
} & Partial<Omit<StackProps, 'title'>>;

export const TextHeader: FunctionComponent<TextHeaderProps> = (props) => {
  const { subtitle, subtitleProps, title, titleProps, ...stackProps } = props;
  return (
    <Stack direction="column" {...stackProps}>
      <Typography {...titleProps}>{title}</Typography>
      {subtitle && <Typography {...subtitleProps}>{subtitle}</Typography>}
    </Stack>
  );
};
